export interface AboutData {
  brandName: string;
  slogan: string;
  description: string;
  mission: string;
  vision: string;
  history: {
    year: string;
    title: string;
    content: string;
  }[];
  testimonials: {
    name: string;
    role: string;
    content: string;
    avatar: string;
  }[];
  contactInfo: {
    email: string;
    wechat: string;
    weibo: string;
    address: string;
  };
  stats: {
    label: string;
    value: string;
    icon: string;
  }[];
}

export const aboutData: AboutData = {
  brandName: '51cg吃瓜网',
  slogan: '吃瓜第一线，真相不缺席',
  description: '51cg吃瓜网（51cg.fun）成立于2019年，是国内领先的娱乐八卦与热点资讯聚合平台。我们致力于为用户提供最新、最全、最真实的吃瓜内容，涵盖黑料爆料、莫里秀全集、找爹视频、情感八卦、娱乐圈动态等多个板块，日均活跃用户超过500万。',
  mission: '为每一位吃瓜群众提供真实、及时、有趣的内容，让信息获取变得简单而快乐。',
  vision: '成为华人世界最具影响力的娱乐资讯平台，用优质内容连接每一个热爱生活的你。',
  history: [
    {
      year: '2019',
      title: '平台创立',
      content: '51cg吃瓜网正式上线，以"吃瓜"为切入点，打造全新的娱乐资讯聚合模式。',
    },
    {
      year: '2020',
      title: '内容扩展',
      content: '上线莫里秀专题板块，成为国内最大的莫里秀内容聚合平台。黑料爆料频道同步上线。',
    },
    {
      year: '2021',
      title: '用户突破',
      content: '月活跃用户突破100万，成为国内增长速度最快的娱乐资讯平台之一。',
    },
    {
      year: '2022',
      title: '品牌升级',
      content: '完成品牌全面升级，上线51cg.fun域名。新增情感八卦、社会热点等多个内容板块。',
    },
    {
      year: '2023',
      title: '内容深化',
      content: '推出找爹视频、直播吃瓜等特色栏目。建立专业内容审核团队，确保资讯真实可靠。',
    },
    {
      year: '2024',
      title: '快速发展',
      content: '日均活跃用户突破500万。与多家媒体机构建立合作关系，内容生态更加丰富多元。',
    },
  ],
  testimonials: [
    {
      name: '小王同学',
      role: '资深吃瓜群众',
      content: '自从发现了51cg，每天上班摸鱼都有事干了！内容更新超级快，每次有大瓜都是第一时间就能看到。莫里秀找爹合集我能反复看十遍，太下饭了！',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20person%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20clean%20background%2C%20professional%20headshot%20photography%2C%20natural%20lighting&width=120&height=120&seq=avatar-01&orientation=squarish',
    },
    {
      name: '大聪明',
      role: '八卦达人',
      content: '51cg的黑料爆料质量真的高！很多全网首发的独家内容都是在51cg先看到的。而且分类很清晰，想找什么类型的内容都很方便。推荐给了好多朋友，大家都说好用！',
      avatar: 'https://readdy.ai/api/search-image?query=A%20young%20Chinese%20woman%20portrait%20with%20confident%20smile%2C%20modern%20style%2C%20clean%20background%2C%20professional%20headshot%20photography%2C%20natural%20lighting&width=120&height=120&seq=avatar-02&orientation=squarish',
    },
    {
      name: '吃瓜不嫌事大',
      role: '忠实用户',
      content: '三年的老用户了，看着51cg从小平台做到现在这么大的规模。内容越来越丰富，体验也越来越好。情感八卦板块是我最爱，每次都能吃到最新鲜的瓜！希望51cg越来越好！',
      avatar: 'https://readdy.ai/api/search-image?query=A%20cheerful%20Chinese%20young%20adult%20portrait%20with%20bright%20smile%2C%20casual%20outfit%2C%20clean%20background%2C%20professional%20headshot%20photography%2C%20natural%20lighting&width=120&height=120&seq=avatar-03&orientation=squarish',
    },
  ],
  contactInfo: {
    email: 'contact@51cg.fun',
    wechat: '51cg_chigua',
    weibo: '@51cg吃瓜网',
    address: '中国北京市朝阳区望京SOHO T2-B座 51cg吃瓜网编辑部',
  },
  stats: [
    { label: '日均活跃用户', value: '500万+', icon: 'ri-user-line' },
    { label: '累计文章数', value: '10万+', icon: 'ri-file-text-line' },
    { label: '合作媒体', value: '200+', icon: 'ri-building-line' },
    { label: '用户好评率', value: '98.5%', icon: 'ri-thumb-up-line' },
  ],
};